import React from 'react'
import { Autocomplete } from 'mui-rff'
import { TagTypes } from '../types/tag'

type TagTypeOption = typeof TagTypes[number]

type TagTypeSelectProps = {
    name: string
    required: boolean
    label: string
    variant: 'filled' | 'outlined' | 'standard'
}

export function TagTypeSelect({
    name,
    required,
    label,
    variant,
}: TagTypeSelectProps) {
    return (
        <Autocomplete
            id="tag-type-select"
            style={{ width: '100%' }}
            name={name}
            label={label}
            options={TagTypes}
            autoHighlight
            getOptionLabel={(option: TagTypeOption) => option.label}
            getOptionValue={(option: TagTypeOption) => option.code}
            renderOption={(option: TagTypeOption) => (
                <React.Fragment>{option.label}</React.Fragment>
            )}
            textFieldProps={{
                required,
                variant,
            }}
        />
    )
}